// No agregamos la exportacion por default, ya que queremos evitar que en los imports se renombre.
let initToken = localStorage.getItem('token') || null;
export const HelpHttp = () => {
    const customFetch = (endpoint, options) => {
        const defaultHeader = {accept: "application/json", 'x-access-token': initToken};

        // const controller = new AbortController();
        // options.signal = controller.signal;

        options.method = options.method || "GET";
        options.headers = options.headers
            ? {...defaultHeader, ...options.headers}
            : defaultHeader;

        options.body = JSON.stringify(options.body) || false;
        if (!options.body) delete options.body;

        //console.log(options);
        // setTimeout(() => controller.abort(), 5000);
        return fetch(endpoint, options)
            .then((res) => {
                    if (res.ok) {
                        return res.json()
                    } else {
                        res.json().then(obj => {
                            // console.log('res.json', obj);
                            if (obj.name === 'NoTokenProvided' || obj.name === 'JsonWebTokenError' || obj.name === 'UserNotFound') {
                                localStorage.removeItem('token');
                                window.location.href = '/login';
                            }
                        });

                        return Promise.reject({
                            err: true,
                            status: res.status || "00",
                            statusText: res.statusText || "Ocurrió un error",
                            body: res
                        })
                    }
                }
            ).catch((err) => {
                // console.log('error catch', err);
                return {
                    err: true,
                    status: err.status || "000",
                    statusText: err.statusText || "Ocurrió un error",
                    body: err.body
                };
            });
    };

    const get = (url, options = {}) => customFetch(url, options);

    const post = (url, options = {}) => {
        options.method = "POST";
        return customFetch(url, options);
    };

    const put = (url, options = {}) => {
        options.method = "PUT";
        return customFetch(url, options);
    };

    const patch = (url, options = {}) => {
        options.method = "PATCH";
        return customFetch(url, options);
    };

    const del = (url, options = {}) => {
        options.method = "DELETE";
        return customFetch(url, options);
    };

    return {get, post, put, patch, del,};
};
